import { render, staticRenderFns } from "./JgpDrop.vue?vue&type=template&id=c5245b2a&"
import script from "./JgpDrop.vue?vue&type=script&lang=js&"
export * from "./JgpDrop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports